import { lazyRouteComponent } from "@tanstack/react-router";

// Plain validator i stället för zod: identisk semantik (coerce + default 0)
// men utan att dra in zod (~65 kB) i startbundlen.
const num = (v: unknown, fallback: number) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : fallback;
};

export const search = (s: Record<string, unknown>): { score: number; total: number } => ({
  score: num(s.score, 0),
  total: num(s.total, 0),
});

const Results = lazyRouteComponent(() => import("./results.view"), "Results");

export const routeOptions = {
  validateSearch: search,
  component: Results,
  head: () => ({
    meta: [
      { title: "Resultat – Alkoholprovet" },
      { name: "description", content: "Ditt resultat efter övning eller provsimulering." },
      { name: "robots", content: "noindex" },
    ],
  }),
};
